import { useState } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { DashboardCardWrapper } from '../../commonComponents/DashboardCardWrapper';

const leadSources = [
    { name: 'Google Ads', value: 35, color: '#7a3a5e', lightBg: '#faf5f8' },
    { name: 'LinkedIn', value: 20, color: '#3b82f6', lightBg: '#eff6ff' },
    { name: 'Meta Ads', value: 15, color: '#a855f7', lightBg: '#faf5ff' },
    { name: 'Email Mktg', value: 12, color: '#14b8a6', lightBg: '#f0fdfa' },
    { name: 'Organic SEO', value: 10, color: '#f59e0b', lightBg: '#fffbeb' },
    { name: 'Events', value: 8, color: '#f43f5e', lightBg: '#fff1f2' },
];

export const LeadSourceOverview = () => {
    const [hoveredSource, setHoveredSource] = useState(null);

    return (
        <DashboardCardWrapper
            headerText={"Lead Sources Overview"}
            headerSubtext={"Distribution across marketing channels"}
            componentStyles={{ height: "100%", width: "100%" }}
        >
            <div className="d-flex align-items-center pt-1" style={{ minHeight: 0 }}>

                <div className="position-relative flex-shrink-0 w-50" style={{ height: "185px" }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={leadSources}
                                cx="50%"
                                cy="50%"
                                innerRadius={66}
                                outerRadius={92}
                                dataKey="value"
                                cornerRadius={4}
                                paddingAngle={3}
                                onMouseEnter={(_, index) => setHoveredSource(leadSources[index])}
                                onMouseLeave={() => setHoveredSource(null)}
                            >
                                {leadSources.map((entry, idx) => (
                                    <Cell
                                        key={idx}
                                        fill={entry.color}
                                        style={{ outline: 'none', cursor: 'pointer' }}
                                    />
                                ))}
                            </Pie>
                        </PieChart>
                    </ResponsiveContainer>

                    <div
                        className="position-absolute d-flex flex-column align-items-center justify-content-center"
                        style={{
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            pointerEvents: 'none',
                        }}
                    >
                        <span className="text-muted fw-medium text-truncate px-1" style={{ fontSize: '10px', maxWidth: '85px' }}>
                            {hoveredSource ? hoveredSource.name : "Top Source"}
                        </span>
                        <h4
                            className="mb-0 fw-bold"
                            style={{
                                fontSize: '1.3rem',
                                color: hoveredSource ? hoveredSource.color : "#7a3a5e",
                                letterSpacing: "-0.02em"
                            }}
                        >
                            {hoveredSource ? `${hoveredSource.value}%` : `${leadSources[0].value}%`}
                        </h4>
                    </div>
                </div>

                <div className=" mt-2 px-1 d-flex flex-column flex-grow-1 gap-2 w-100  " style={{ minHeight: 0, }}>
                    {leadSources.map((source) => {
                        const isHovered = hoveredSource?.name === source.name;
                        return (
                            <div key={source.name} >
                                <div
                                    className="d-flex align-items-center justify-content-between p-2 rounded-2 transition-all cursor-pointer"
                                    style={{
                                        border: `1px solid ${isHovered ? source.color : '#e2e8f0'}`,
                                        borderLeft: `3px solid ${source.color}`,
                                        backgroundColor: '#ffffff',
                                        boxShadow: isHovered ? `0 2px 8px ${source.color}15` : 'none'
                                    }}
                                    onMouseEnter={() => setHoveredSource(source)}
                                    onMouseLeave={() => setHoveredSource(null)}
                                >
                                    <span
                                        className="fw-medium text-truncate me-1"
                                        style={{ fontSize: "11px", color: isHovered ? "#0f172a" : "#475569" }}
                                    >
                                        {source.name}
                                    </span>

                                    <span
                                        className="fw-semibold px-1.5 py-0.5 rounded flex-shrink-0"
                                        style={{
                                            fontSize: "10px",
                                            color: source.color,
                                            backgroundColor: source.lightBg
                                        }}
                                    >
                                        {source.value}%
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </DashboardCardWrapper>
    );
};